export default class HeaderScroll {
    constructor({
        headerSelector = '.header',
        triggerSelector = '.header-scroll-trigger',
        activeClass = 'is-scrolled',
        offset = 0
    } = {}) {
        this.header = document.querySelector(headerSelector);
        this.trigger = document.querySelector(triggerSelector);
        this.activeClass = activeClass;
        this.offset = offset;

        if (!this.header || !this.trigger) return;

        this.handleScroll = this.handleScroll.bind(this);
        this.init();
    }

    getTriggerTop() {
        return this.trigger.getBoundingClientRect().top + window.scrollY;
    }

    handleScroll() {
        if (window.scrollY >= this.getTriggerTop() - this.offset) {
            this.header.classList.add(this.activeClass);
        } else {
            this.header.classList.remove(this.activeClass);
        }
    }

    init() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleScroll);
        this.handleScroll(); // run on load
    }

    destroy() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleScroll);
    }
}
